import { useEffect, useRef, useState } from "react";
import "./Bookings.css";
import {
  validateAndFormatPostCodeFromWeb,
  validatePostCode,
} from "../../utils/postCodeValidation";
import { validateEmail } from "../../utils/contactValidation";
import { useMultistepForm } from "../../hooks/MultiStepForm/useMultiStepForm";
import SenderForm from "./components/SenderForm/SenderForm";
import ReceiverForm from "./components/ReceiverForm/ReceiverForm";
import ParcelForm from "./components/ParcelForm/ParcelForm";
import DeliveryPlanStep from "./components/DeliveryPlanStep/DeliveryPlanStep";
import { BsArrowRight } from "react-icons/bs";
import { BsArrowLeft } from "react-icons/bs";
import PaymentMethod from "./components/PaymentMethod/PaymentMethod";
import ProgressBar from "./components/ProgressBar/ProgressBar";
import PickupForm from "./components/PickupForm/PickupForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import ShippingInformation from "./components/ShippingInformation/ShippingInformation";
import axios from "axios";
import dayjs from "dayjs";
import Finalize from "./components/Finalize/Finalize";
import WhereToGo from "./components/WhereToGo/WhereToGo";
import Swal from "sweetalert2";
import { useHref, useNavigate, useLocation } from "react-router-dom";
import Payment from "./components/Payment/Payment";
import GetLocalStorageUserId from "../sharedComponents/GetLocalStorageuserId";
import sideImg from "../../../src/assets/images/booking/sideImage.png";
import jwtDecode from "jwt-decode";
import UserTokenHandler from "../sharedComponents/UserTokenHandler";
import { redirectToIdentityLogin } from "../../utils/identityLogin";
import {
  ensureFreshAccessToken,
  getAccessToken,
  isAccessTokenExpired,
} from "../../utils/authToken";
import {
  clearWalkInDraft,
  markWalkInDraftRestoredToast,
  readWalkInDraft,
  saveWalkInDraft,
  syncWalkInDraftToServer,
} from "../../utils/walkInBookingDraft";
import { resolveCurrencySymbol } from "../../utils/formatCurrency";
import StripePayment from "./components/Payment/StripePayment";
import ManualBankPayment from "./components/Payment/ManualBankPayment";
import { clearPaymentSlipUploadSessionFlags } from "../payments/paymentSlipDebug";
import { markSelfParcelBookingCreated } from "../../utils/parcelBookingNotifications";
import { dispatchNotificationsRefresh } from "../../types/notification.types";
import { refreshCustomerDashboardData } from "../../utils/customerDashboardRefresh";
import { isAdminUser, isCustomerUser } from "../../utils/jwtRole";
import {
  isMangoShipmentReady,
  loadMangoTransitCost,
  readMangoPricingDraft,
  summarizeTransitCostResults,
} from "../../utils/mangoBookingFlow";
import { isMangoFeatureEnabled } from "../../utils/featureFlags";
import { MANUAL_PAYMENT_TYPE_ID } from "../../utils/manualPayment";
import { createManualBankPaymentInvoice } from "../../api/manualPaymentApi";
import { saveOriginalMeasurementSnapshot } from "../../utils/invoiceManagerSlip";
import WalkInAccountPanel from "./components/WalkInAccounts/WalkInAccountPanel";
import WalkInSuccessModal from "./components/WalkInAccounts/WalkInSuccessModal";
import WalkInSummary from "./components/WalkInAccounts/WalkInSummary";
import { createAdminWalkInBooking } from "../../api/adminWalkInBookingApi";
import {
  buildWalkInAccountPayload,
  buildAdminWalkInCreateBody,
  emptyWalkInFields,
  validateWalkInAccounts,
  applyWalkInFinalPrice,
  applyPayableOverrideToTransitCost,
  walkInItemWeightRates,
  walkInSuggestedGross,
} from "../../utils/adminWalkInBooking";
import { getInvoicesByParcelId } from "../../api/invoiceManagerApi";
import {
  invoiceNumberOf,
  pickLatestInvoice,
} from "../../utils/bookingHistory";
const apiAddress = process.env.REACT_APP_API_URL;

const DEFAULT_CARGO_TYPE_ID = 1;

function getDefaultShipmentFields() {
  const today = dayjs();
  return {
    cargoType: String(DEFAULT_CARGO_TYPE_ID),
    selectedShipmentArrivalDate: today.format("YYYY-MM-DD"),
    shipmentArrivalDate: {
      day: today.format("dddd"),
      date: today.date(),
      month: today.format("MMMM"),
      year: String(today.year()),
    },
  };
}

function money(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}

/** Delivery-plan amount is the shipping price. Do not also add box/route list prices. */
function alignTransitionCostWithDeliveryPlan(row, request) {
  if (!row || !request?.deliveryPlanId) return row;
  const strip = money(row.dimensionCost) + money(row.routeCost);
  if (strip <= 0) return row;
  const net = Math.max(0, money(row.totalCostWithoutVAT) - strip);
  const after = money(row.afterDiscountCost) > 0
    ? Math.max(0, money(row.afterDiscountCost) - strip)
    : net;
  const vatPct = money(row.vatPercentage);
  const vatBase = after || net;
  const vat =
    vatPct > 0
      ? Math.round(vatBase * vatPct) / 100
      : Math.max(0, money(row.vatPercentageAmount ?? row.vatAmount) * (vatBase / (vatBase + strip) || 0));
  return {
    ...row,
    dimensionCost: 0,
    routeCost: 0,
    totalCostWithoutVAT: net,
    afterDiscountCost: after,
    vatPercentageAmount: vat,
    vatAmount: vat,
    totalCostWithVAT: vatBase + vat,
    totalCost: vatBase + vat,
  };
}

const Bookings = ({
  tittle,
  flow = "standard",
  variant,
  onWalkInCreated,
  onWalkInDraftChange,
  onWalkInStartAnother,
}) => {
  const isMangoFlow = flow === "mango";
  const isWalkInFlow = flow === "walkin";
  const restoredWalkInDraft = isWalkInFlow ? readWalkInDraft() : null;
  const restoredPendingSubmit = Boolean(restoredWalkInDraft?.pendingSubmit);
  const isAdminEmbed = variant === "admin" || isWalkInFlow;
  const mangoFeatureEnabled = isMangoFeatureEnabled();
  const backendUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const move = useNavigate();
  // const [decodedToken, setDecodedToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const [currencyTypes, setCurrencyTypes] = useState([]);
  const [exchangeRates, setExchangeRates] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(
    restoredWalkInDraft?.selectedCurrency || "GBP",
  );
  UserTokenHandler();
  useEffect(() => {
    setUserId(GetLocalStorageUserId());
  }, []);

  // Require login for bookings; if token not present and no user details, redirect to Identity with returnUrl back here.
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const hasTokenInUrl = !!queryParams.get("token");
    const storedUser = localStorage.getItem("sundorbonBookingUserDetails");
    const storedToken =
      localStorage.getItem("sundorbonToken") || localStorage.getItem("token");

    if (!hasTokenInUrl && (!storedUser || !storedToken)) {
      const returnUrl = `${window.location.origin}${location.pathname}${location.search}`;
      redirectToIdentityLogin(returnUrl);
    }
  }, [location.pathname, location.search]);

  // Mango shipment page: only after landing-page modal + cost calculation
  useEffect(() => {
    if (!isMangoFlow) return;
    if (!mangoFeatureEnabled) {
      move("/bookings", { replace: true });
      return;
    }
    const draft = readMangoPricingDraft();
    if (!draft || !isMangoShipmentReady()) {
      toast.error("Please complete mango booking details on the home page first.");
      move("/", { replace: true });
    }
  }, [isMangoFlow, mangoFeatureEnabled, move]);

  // Clear pricing draft when website is closed
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("sundorbonPricingDraft");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  // useEffect(() => {
  //   // Extract the token from the URL
  //   const queryParams = new URLSearchParams(location.search);
  //   const Sundarbantoken = queryParams.get("token");

  //   if (Sundarbantoken) {
  //     // Store token in localStorage
  //     localStorage.setItem("Sundarbantoken", Sundarbantoken);

  //     // Decode token to get user details
  //     const decoded = jwtDecode(Sundarbantoken); // Decoding JWT token
  //     setDecodedToken(decoded);

  //     // Optionally, store decoded details in localStorage for easier access
  //     localStorage.setItem("decodedToken", JSON.stringify(decoded));
  //   } else {
  //     // Handle missing token (e.g., redirect to login)
  //     move("/login");
  //   }
  // }, [location.search, move]);

  // Use decodedToken for rendering user-specific content
  console.log(userId);

  // get local storage data.
  const localdata = localStorage.getItem("sundorbonBookingUserDetails");
  const localStorageObj = JSON.parse(localdata);
  console.log(localStorageObj);

  // Clear pricing draft when website is closed
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("sundorbonPricingDraft");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  // const move = useNavigate();
  const INITIAL_DATA = {
    route: "",
    senderName: "",
    senderEmail: "",
    senderMobileNumber: "",
    senderCountry: "",
    senderLandmark: "",
    pickupLandmark: "",
    senderCity: "",
    senderPostCode: "",
    senderDoorNo: "",
    senderStreetName: "",
    senderRemarks: "",
    pickupCity: "",
    pickupCountry: "",
    senderAddress: "",
    receiverName: "",
    receiverEmail: "",
    receiverMobileNumber: "",
    receiverCountry: "",
    receiverLandmark: "",
    receiverCity: "",
    receiverPostCode: "",
    receiverDoorNo: "",
    receiverStreetName: "",
    receiverRemarks: "",
    receiverAddress: "",
    numberOfItems: "",
    parcelContent: "",
    shipmentTime: "",
    producDetails: [
      {
        productGroup: "",
        productGroupName: "",
        productType: "",
        productTypeName: "",
        itemDescription: "",
        productValue: "",
        productQty: 0,
        deliveryPlanId: "",
        deliveryPlanName: "",
      },
    ],
    preferredDeliveryPlanId: "",
    productGroup: "",
    productType: "",
    itemDescription: "",
    productValue: "",

    packaging: "",
    fragileItems: "",
    preset: "A4 Envelope",
    additionalInfo: "",
    productWeight: "1",
    productLength: "12",
    productWidth: "9",
    productHeight: "1",
    paymentTypeId: "2",
    paymentInvoiceNo: "",
    shipmentType: "",
    IsScheduled: "",
    scheduledDate: {},
    pickupLocation: "",
    pickupWeight: "",
    pickupInstructions: "",
    pickupTimeFrom: "",
    pickupTimeTo: "",
    cargoType: String(DEFAULT_CARGO_TYPE_ID),
    shipmentArrivalDate: getDefaultShipmentFields().shipmentArrivalDate,
    selectedShipmentArrivalDate:
      getDefaultShipmentFields().selectedShipmentArrivalDate,
    scheduledDateToggleValue: "",
    pickupTimeFromToggleValue: "",
    pickupTimeToToggleValue: "",
    pickupAsSenderCheckToggle: false,
    BookedById: "",
    ...emptyWalkInFields,
  };

  const [data, setData] = useState(() => ({
    ...INITIAL_DATA,
    ...(restoredWalkInDraft?.data || {}),
  }));

  useEffect(() => {
    if (!isWalkInFlow) return;
    let lead = location.state?.crmLead;
    if (!lead && location.state?.crmLeadQueryId) {
      try {
        const raw = sessionStorage.getItem("crmLeadPrefill");
        lead = raw ? JSON.parse(raw) : null;
      } catch {
        lead = null;
      }
    }
    if (!lead) return;
    updateFields({
      senderName: lead.senderName || "",
      senderMobileNumber: lead.senderPhone || "",
      senderEmail: lead.senderEmail || "",
      senderAddress: lead.senderAddress || "",
      itemDescription: lead.itemDescription || "",
      additionalInfo: lead.itemDescription
        ? `CRM lead #${lead.queryId || ""} — ${lead.itemDescription}`
        : `CRM lead #${lead.queryId || ""}`,
    });
  }, [isWalkInFlow, location.state]);
  console.dir(data);
  function updateFields(fields) {
    setData((prev) => {
      return { ...prev, ...fields };
    });
  }

  // Prefill booking form from pricing draft (saved by Quotation modal "Book Now")
  useEffect(() => {
    const PRICING_DRAFT_KEY = "sundorbonPricingDraft";
    const raw = localStorage.getItem(PRICING_DRAFT_KEY);
    if (!raw) return;

    try {
      const draft = JSON.parse(raw);
      if (!draft?.routeId) return;
      if (!isMangoFlow && draft?.pricingType === "mango") return;
      if (isMangoFlow && draft?.pricingType !== "mango") return;

      const parcel = draft?.parcel || {};

      // Basic prefill (route, post codes, parcel fields)
      updateFields({
        route: String(draft.routeId),
        senderPostCode: (draft.fromPostCode || "").toUpperCase(),
        receiverPostCode: (
          draft.receiverPostCode ||
          draft.toPostCode ||
          ""
        ).toUpperCase(),
        ...(isMangoFlow && draft.mangoSetupComplete
          ? {
              receiverName: draft.receiverName || "",
              receiverEmail: draft.receiverEmail || "",
              receiverMobileNumber: draft.receiverMobileNumber || "",
              receiverCountry: draft.receiverCountry
                ? String(draft.receiverCountry)
                : "",
              receiverCity: draft.receiverCity ? String(draft.receiverCity) : "",
              receiverLandmark: draft.receiverLandmark || "",
              receiverDoorNo: draft.receiverDoorNo || "",
              receiverStreetName: draft.receiverStreetName || "",
              receiverRemarks: draft.receiverRemarks || "",
              receiverAddress: draft.receiverAddress || "",
              additionalInfo: draft.additionalInfo || "",
            }
          : {}),
        // Prefer manual parcel values from draft; allow user to change in form
        preset: "",
        productWeight:
          parcel.weight !== undefined &&
          parcel.weight !== null &&
          parcel.weight !== ""
            ? String(parcel.weight)
            : "",
        productLength:
          parcel.length !== undefined &&
          parcel.length !== null &&
          parcel.length !== ""
            ? String(parcel.length)
            : "",
        productWidth:
          parcel.width !== undefined &&
          parcel.width !== null &&
          parcel.width !== ""
            ? String(parcel.width)
            : "",
        productHeight:
          parcel.height !== undefined &&
          parcel.height !== null &&
          parcel.height !== ""
            ? String(parcel.height)
            : "",
        preferredDeliveryPlanId: draft.deliveryPlanId || "",
      });

      // Mango pricing: preselect Item Group (Category) = Fruits (id 19) and Item Type = Mango (id 18)
      if (isMangoFlow && draft?.pricingType === "mango") {
        setData((prev) => {
          const current = Array.isArray(prev.producDetails)
            ? prev.producDetails
            : [];
          const first = current[0] || {
            productGroup: "",
            productGroupName: "",
            productType: "",
            productTypeName: "",
            itemDescription: "",
            productValue: "",
            productQty: 0,
          };

          const mangoQty = parseInt(draft?.mango?.qty, 10);
          const updated = [
            {
              ...first,
              productGroup: 19,
              productGroupName: "Fruits",
              productType: 18,
              productTypeName: "Mango",
              productQty: mangoQty >= 3 ? mangoQty : 3,
            },
            ...current.slice(1),
          ];

          return {
            ...prev,
            producDetails: updated,
            productGroup: 19,
            productType: 18,
          };
        });
      }
    } catch (err) {
      console.log("Invalid pricing draft:", err?.message || err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMangoFlow]);

  const [transitCost, setTransitCost] = useState(
    () => restoredWalkInDraft?.transitCost || [],
  );
  const [mangoTransitCostLoaded, setMangoTransitCostLoaded] = useState(false);

  console.log(transitCost);
  const [arrivalDate, setArrivalDate] = useState({});
  // fetching booking form data.
  const [arrivalDateInfo, setArivalDateInfo] = useState([]);

  const [fetchedFormData, setfetchedFormData] = useState({});
  const [routesLoading, setRoutesLoading] = useState(true);
  const [fruitsWeights, setFruitsWeights] = useState([]);
  const [dimensions, setDimensions] = useState([]);
  const [presets, setPresets] = useState([]);
  const formKeys = fetchedFormData;

  useEffect(() => {
    /// fetching arrival date info.
    // axios.get("./dummyData.json").then((res) => setArivalDateInfo(res.data));

    // api get request url and state seter functions and ulrs.
    const getFormData = [
      {
        url: "PaymentTypeMethod",
        key: "paymentMethod",
      },
      {
        url: "Country",
        key: "country",
      },
      {
        url: "city",
        key: "city",
      },
      {
        url: "ProductType",
        key: "ProductType",
      },
      {
        url: "ParcelContent",
        key: "ParcelContent",
      },
      {
        url: "Prohibiteditem",
        key: "Prohibiteditem",
      },
      {
        url: "Cargotype",
        key: "Cargotype",
      },
      {
        url: "Route",
        key: "Route",
      },
      {
        url: "itemType",
        key: "itemType",
      },
    ];

    // Fetched form data and set to state.

    // getFormData?.forEach(({ url, key }) => {
    //   axios
    //     .get(apiAddress + url)
    //     .then((res) => {
    //       formKeys[key] = res.data;
    //       return setfetchedFormData({ ...formKeys });
    //     })
    //     .catch((err) => {
    //       console.log(err.message);
    //     });
    // });

    // Fetch all data in parallel for better performance
    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    // Prioritize Route API call - fetch it first
    const routeData = getFormData.find((item) => item.key === "Route");
    const otherData = getFormData.filter((item) => item.key !== "Route");

    // Fetch Route first for faster dropdown loading
    if (routeData) {
      axios
        .get(apiAddress + routeData.url, { headers })
        .then((res) => {
          formKeys[routeData.key] = res.data;
          setfetchedFormData({ ...formKeys });
          setRoutesLoading(false);
        })
        .catch((err) => {
          console.log(`Error fetching ${routeData.key}:`, err.message);
          setRoutesLoading(false);
        });
    }

    // Fetch remaining data in parallel
    Promise.all(
      otherData.map(({ url, key }) =>
        axios
          .get(apiAddress + url, { headers })
          .then((res) => ({ key, data: res.data }))
          .catch((err) => {
            console.log(`Error fetching ${key}:`, err.message);
            return { key, data: [] }; // Return empty array on error to prevent blocking
          }),
      ),
    ).then((results) => {
      setfetchedFormData((prev) => {
        const updatedFormData = { ...prev, ...formKeys };
        results.forEach(({ key, data }) => {
          updatedFormData[key] = data;
        });
        return updatedFormData;
      });
    });

    // Fetch dimensions and use them as presets
    axios
      .get(`${apiAddress}Dimension`, { headers })
      .then((res) => {
        const dimensionsData = res.data || [];
        setDimensions(dimensionsData);

        // Convert dimensions to presets format
        // Filter only active dimensions if needed, or use all
        const presetsData = dimensionsData
          .filter((dim) => dim.isActive !== false) // Only show active dimensions
          .map((dim) => ({
            id: dim.id,
            name:
              dim.dimensionName?.replace(/_/g, " ") || dim.dimensionName || "", // Replace underscores with spaces
            dimensionName: dim.dimensionName,
            length: dim.length,
            width: dim.width,
            height: dim.height,
            weight: dim.weight || null, // Weight may not be in Dimension API
            routeId: dim.routeId,
            routeName: dim.routeName,
            isActive: dim.isActive,
          }));

        setPresets(presetsData);
      })
      .catch((err) => {
        console.log("Error fetching dimensions:", err.message);
        setDimensions([]);
        setPresets([]);
      });

    axios
      .get(`${apiAddress}Weight`, { headers })
      .then((weightRes) => {
        const allWeights = weightRes.data || [];
        setfetchedFormData((prev) => ({ ...prev, Weight: allWeights }));
        setFruitsWeights(
          allWeights.filter(
            (weight) =>
              weight.itemCategoryId === 19 ||
              String(weight.itemCategoryName || "").toLowerCase() === "fruits",
          ),
        );
      })
      .catch((err) => {
        console.log("Error fetching weights:", err.message);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Pre-fill sender info for mango pricing (separate effect that runs after fetchedFormData is available)
  useEffect(() => {
    const PRICING_DRAFT_KEY = "sundorbonPricingDraft";
    const raw = localStorage.getItem(PRICING_DRAFT_KEY);
    if (!raw) return;

    try {
      const draft = JSON.parse(raw);
      if (
        isMangoFlow &&
        draft?.pricingType === "mango" &&
        draft?.senderInfo &&
        fetchedFormData.country &&
        fetchedFormData.city
      ) {
        const { country, city } = fetchedFormData;
        // Find UK country (id 22) - check both id and name (case-insensitive)
        const ukCountry = country?.find(
          (c) => c.id === 22 || (c.name && c.name.toLowerCase() === "uk"),
        );
        // Find London city - case-insensitive match
        const londonCity = city?.find(
          (c) => c.name && c.name.toLowerCase() === "london",
        );

        updateFields({
          senderName: draft.senderInfo.senderName || "",
          senderEmail: draft.senderInfo.senderEmail || "",
          senderMobileNumber: draft.senderInfo.senderMobileNumber || "",
          senderCountry: ukCountry ? String(ukCountry.id) : "",
          senderCity: londonCity ? String(londonCity.id) : "",
          senderAddress: draft.senderInfo.senderAddress || "",
          senderPostCode: draft.senderInfo.senderPostCode || "",
        });
      }
    } catch (err) {
      console.log("Error prefilling sender info:", err?.message || err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedFormData, isMangoFlow]);

  // Mango: prefill parcel dimensions/weight from selected box (weightId) once data loads
  useEffect(() => {
    if (!isMangoFlow) return;
    const draft = readMangoPricingDraft();
    if (!draft?.mango?.weightId || fruitsWeights.length === 0) return;

    const weightId = parseInt(draft.mango.weightId, 10);
    const weight = fruitsWeights.find((w) => w.id === weightId);
    const dimId = weight?.dimensionId ?? draft.mango?.dimensionId;
    const dim = dimensions.find((d) => d.id === parseInt(dimId, 10));
    const parcel = draft.parcel || {};
    const parsedQty = parseInt(draft.mango?.qty, 10);
    const mangoQty = Math.min(
      5,
      Math.max(1, Number.isFinite(parsedQty) ? parsedQty : 1),
    );

    const length = dim?.length ?? parcel.length ?? "";
    const width = dim?.width ?? parcel.width ?? "";
    const height = dim?.height ?? parcel.height ?? "";
    const weightVal =
      weight?.minimumWeight ?? weight?.maximumWeight ?? parcel.weight ?? "";

    setData((prev) => {
      const current = Array.isArray(prev.producDetails) ? prev.producDetails : [];
      const first = current[0] || {};
      const updatedFirst = {
        ...first,
        productGroup: 19,
        productGroupName: "Fruits",
        productType: 18,
        productTypeName: "Mango",
        itemDescription: "mango",
        productValue: "0",
        productQty: mangoQty,
        itemPackaging: "No",
        itemLength: length !== "" && length != null ? String(length) : first.itemLength,
        itemWidth: width !== "" && width != null ? String(width) : first.itemWidth,
        itemHeight: height !== "" && height != null ? String(height) : first.itemHeight,
        itemWeight:
          weightVal !== "" && weightVal != null ? String(weightVal) : first.itemWeight,
      };

      return {
        ...prev,
        packaging: "No",
        productLength:
          length !== "" && length != null ? String(length) : prev.productLength,
        productWidth:
          width !== "" && width != null ? String(width) : prev.productWidth,
        productHeight:
          height !== "" && height != null ? String(height) : prev.productHeight,
        productWeight:
          weightVal !== "" && weightVal != null
            ? String(weightVal)
            : prev.productWeight,
        producDetails: [updatedFirst, ...current.slice(1)],
        productGroup: 19,
        productType: 18,
      };
    });
  }, [fruitsWeights, dimensions, isMangoFlow]);

  // api response data from shipment arrival date page.

  const [pickUpCost, setPickUpCost] = useState(
    () => restoredWalkInDraft?.pickUpCost || 0,
  );
  const [routeCost, setRouteCost] = useState(
    () => restoredWalkInDraft?.routeCost || 0,
  );
  const [itemTypeCost, setItemTypeCost] = useState(
    () => restoredWalkInDraft?.itemTypeCost || 0,
  );
  const [itemCategoryCost, setItemCategoryCost] = useState(
    () => restoredWalkInDraft?.itemCategoryCost || 0,
  );
  const [weightCost, setWeightCost] = useState(
    () => restoredWalkInDraft?.weightCost || 0,
  );
  const [dimensionCost, setDimensionCost] = useState(
    () => restoredWalkInDraft?.dimensionCost || 0,
  );
  const [extraPackagingCost, setExtraPackagingCost] = useState(
    () => restoredWalkInDraft?.extraPackagingCost || 0,
  );
  const [cargoCost, setCargoCost] = useState(
    () => restoredWalkInDraft?.cargoCost || 0,
  );
  const [shippingServicePercentage, setShippingServicePercentage] = useState(0);
  const [shippingServiceAmount, setShippingServiceAmount] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [vatAmount, setVatAmount] = useState(0);
  const [vatAmountPercentage, setVatAmountPercentage] = useState(
    () => restoredWalkInDraft?.vatAmountPercentage || 0,
  );
  const [totalCost, setTotalCost] = useState(
    () => restoredWalkInDraft?.totalCost || 0,
  );
  const [discountedOfferId, setDiscountedOfferId] = useState(null);
  const [shippingServiceId, setShippingServiceId] = useState(null);
  const [dimensionId, setDimensionId] = useState(null);
  const [weightId, setWeightId] = useState(null);

  // parcel barcode number.
  const [bookingBarcodeNumber, setBookingBarcodeNumber] = useState(null);
  const [manualInvoiceNumber, setManualInvoiceNumber] = useState("");
  const [manualOrderAmount, setManualOrderAmount] = useState("");
  const [walkInSuccess, setWalkInSuccess] = useState(null);
  const [walkInStayOnForm, setWalkInStayOnForm] = useState(false);
  const skipWalkInDraftRef = useRef(false);
  const serverDraftTimerRef = useRef(null);

  // Load transit cost calculated on the landing page before Create shipment
  useEffect(() => {
    if (!isMangoFlow || mangoTransitCostLoaded) return;
    const stored = loadMangoTransitCost();
    if (!stored?.length) return;

    const summary = summarizeTransitCostResults(stored);
    setTransitCost(summary.transitionCostResults);
    setPickUpCost(summary.totalPickUpCost);
    setRouteCost(summary.totalRouteCost);
    setItemCategoryCost(summary.totalItemCategoryCost);
    setItemTypeCost(summary.totalItemTypeCost);
    setWeightCost(summary.totalWeightCost);
    setDimensionCost(summary.totalDimensionCost);
    setExtraPackagingCost(summary.totalExtraPackagingCost);
    setCargoCost(summary.totalCargoCost);
    setTotalCost(summary.totalCost);
    setVatAmountPercentage(summary.vatPercentageAmount);
    setMangoTransitCostLoaded(true);
  }, [isMangoFlow, mangoTransitCostLoaded]);

  useEffect(() => {
    axios
      .get(`${backendUrl}Currency/GetAllActiveCurrency`)
      .then((res) => setCurrencyTypes(res.data))
      .catch((err) => {
        console.log(err.message);
        toast.error("Failed to load currency");
      });
  }, [backendUrl]);

  useEffect(() => {
    axios
      .get(`${backendUrl}Currency/GetAllCurrencyExchangeRate`)
      .then((res) => setExchangeRates(res.data))
      .catch((err) => {
        console.log(err.message);
        toast.error("Failed to load currency rate");
      });
  }, [backendUrl]);

  const getRate = (targetCurrency) => {
    if (targetCurrency === "GBP") return 1;
    const rateObj = exchangeRates.find(
      (r) => r.baseCurrency === "GBP" && r.targetCurrency === targetCurrency,
    );
    return rateObj ? rateObj.rate : 1;
  };

  const getCurrencySymbol = (currency) => {
    const match = currencyTypes.find((c) => c.currencyType === currency);
    return resolveCurrencySymbol(match?.symbol, currency || "GBP");
  };

  const convert = (amount) => {
    const rate = getRate(selectedCurrency);
    return (amount * rate).toFixed(2);
  };

  // Create the utilities object
  const currencyUtils = {
    getRate,
    getCurrencySymbol,
    convert,
    selectedCurrency,
    setSelectedCurrency,
    currencyTypes,
    exchangeRates,
  };

  const baseSteps = isMangoFlow
    ? [
        <Finalize
          {...data}
          bookingBarcodeNumber={bookingBarcodeNumber}
          fetchedFormData={fetchedFormData}
          transitCost={transitCost}
          updateFields={updateFields}
          currencyUtils={currencyUtils}
        />,
        <PaymentMethod
          fetchedFormData={fetchedFormData}
          {...data}
          paymentTypeId={data.paymentTypeId}
          updateFields={updateFields}
        />,
      ]
    : [
        <WhereToGo
          routesLoading={routesLoading}
          {...data}
          updateFields={updateFields}
          fetchedFormData={fetchedFormData}
        />,
        <SenderForm
          {...data}
          fetchedFormData={fetchedFormData}
          updateFields={updateFields}
          emailRequired={!isWalkInFlow}
        />,
        <ReceiverForm
          {...data}
          fetchedFormData={fetchedFormData}
          updateFields={updateFields}
          emailRequired={!isWalkInFlow}
        />,
        ...(isWalkInFlow
          ? [
              <WalkInAccountPanel
                {...data}
                updateFields={updateFields}
              />,
            ]
          : []),
        <ParcelForm
          {...data}
          fetchedFormData={fetchedFormData}
          updateFields={updateFields}
          fruitsWeights={fruitsWeights}
          dimensions={dimensions}
          presets={presets}
          showWeightRate={isWalkInFlow}
          weightBands={fetchedFormData?.Weight || []}
        />,
        <DeliveryPlanStep
          {...data}
          fetchedFormData={fetchedFormData}
          updateFields={updateFields}
          selectedCurrency={selectedCurrency}
          pricingDeliveryPlanId={data.preferredDeliveryPlanId || ""}
        />,
        ...(isWalkInFlow
          ? [
              <PaymentMethod
                fetchedFormData={fetchedFormData}
                {...data}
                paymentTypeId={data.paymentTypeId}
                updateFields={updateFields}
              />,
              <WalkInSummary
                data={data}
                fetchedFormData={fetchedFormData}
                transitCost={transitCost}
                selectedCurrency={selectedCurrency}
                totalCost={totalCost}
                vatAmountPercentage={vatAmountPercentage}
                updateFields={updateFields}
              />,
            ]
          : [
              <Finalize
                {...data}
                bookingBarcodeNumber={bookingBarcodeNumber}
                fetchedFormData={fetchedFormData}
                transitCost={transitCost}
                updateFields={updateFields}
                currencyUtils={currencyUtils}
              />,
              <PaymentMethod
                fetchedFormData={fetchedFormData}
                {...data}
                paymentTypeId={data.paymentTypeId}
                updateFields={updateFields}
              />,
            ]),
      ];

  // Define payment method steps
  const paymentSteps = {
    2: [<StripePayment />], // Online Payment (Stripe)
    [MANUAL_PAYMENT_TYPE_ID]: [
      <ManualBankPayment
        invoiceNumber={manualInvoiceNumber}
        orderAmount={manualOrderAmount}
        currencySymbol={resolveCurrencySymbol(selectedCurrency)}
      />,
    ],
  };

  // Combine all steps (walk-in stays in the admin wizard — no Stripe/bank extra screens)
  const allSteps = [
    ...baseSteps,
    ...(isWalkInFlow ? [] : paymentSteps[data.paymentTypeId] || []),
  ];

  const { currentStepIndex, step, isFirstStep, isLastStep, back, next, goTo } =
    useMultistepForm(allSteps, restoredWalkInDraft?.currentStepIndex || 0);

  const persistWalkInWizard = (extra = {}) => {
    if (!isWalkInFlow || skipWalkInDraftRef.current) return null;
    const saved = saveWalkInDraft({
      currentStepIndex,
      data,
      selectedCurrency,
      transitCost,
      vatAmountPercentage,
      totalCost,
      pickUpCost,
      routeCost,
      itemTypeCost,
      itemCategoryCost,
      weightCost,
      dimensionCost,
      extraPackagingCost,
      cargoCost,
      shippingServiceAmount,
      discountAmount,
      ...extra,
    });
    if (saved && typeof onWalkInDraftChange === "function") {
      onWalkInDraftChange(saved);
    }
    return saved;
  };

  const flushWalkInDraftToServer = async () => {
    if (serverDraftTimerRef.current) {
      window.clearTimeout(serverDraftTimerRef.current);
      serverDraftTimerRef.current = null;
    }
    const saved = persistWalkInWizard();
    if (!saved) return null;
    try {
      const synced = await syncWalkInDraftToServer(saved);
      if (synced && typeof onWalkInDraftChange === "function") {
        onWalkInDraftChange(synced);
      }
      return synced || saved;
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Could not save the draft to the server.",
      );
      return null;
    }
  };

  useEffect(() => {
    const saved = persistWalkInWizard();
    if (!saved || skipWalkInDraftRef.current) return undefined;
    if (serverDraftTimerRef.current) {
      window.clearTimeout(serverDraftTimerRef.current);
    }
    serverDraftTimerRef.current = window.setTimeout(() => {
      if (skipWalkInDraftRef.current) return;
      syncWalkInDraftToServer(saved)
        .then((synced) => {
          if (skipWalkInDraftRef.current) return;
          if (synced && typeof onWalkInDraftChange === "function") {
            onWalkInDraftChange(synced);
          }
        })
        .catch(() => {});
    }, 1600);
    return () => {
      if (serverDraftTimerRef.current) {
        window.clearTimeout(serverDraftTimerRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isWalkInFlow,
    currentStepIndex,
    data,
    selectedCurrency,
    transitCost,
    vatAmountPercentage,
    totalCost,
    pickUpCost,
    routeCost,
  ]);

  useEffect(() => {
    if (!isWalkInFlow || !restoredPendingSubmit) return;
    if (!markWalkInDraftRestoredToast()) return;
    saveWalkInDraft({ pendingSubmit: false });
    toast.info("Session refreshed. Click Create booking to finish.");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const receiverStepIndex = 2;
  const walkInAccountStepIndex = isWalkInFlow ? 3 : -1;
  const walkInStepOffset = isWalkInFlow ? 1 : 0;
  const parcelStepIndex = 3 + walkInStepOffset;
  const deliveryStepIndex = 4 + walkInStepOffset;
  const finalizeStepIndex = isMangoFlow ? 0 : isWalkInFlow ? -1 : 5;
  const paymentMethodStepIndex = isMangoFlow ? 1 : 6;

  // If we come from /payment-failed "Try again", jump user straight back to Stripe step.
  const resumePaymentRequestedRef = useRef(false);
  useEffect(() => {
      if (location.state?.resumePayment) {
      resumePaymentRequestedRef.current = true;
      updateFields({ paymentTypeId: "2" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  useEffect(() => {
    if (!resumePaymentRequestedRef.current) return;
    if (String(data.paymentTypeId) !== "2") return;
    // StripePayment is the last step once paymentTypeId=2
    goTo(allSteps.length - 1);
    resumePaymentRequestedRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.paymentTypeId, allSteps.length]);

  const validateFields = () => {
    const isManualFilled =
      data.productWeight &&
      data.productLength &&
      data.productWidth &&
      data.productHeight;
    if (!data.preset && !isManualFilled) {
      toast.error("Please select a preset or fill in all the fields.");
      return false;
    }
    // if (isManualFilled) {
    //     updateFields({ preset: '' }); // Reset preset if manual fields are filled
    // }
    const { scheduledDate, IsScheduled, pickupTimeTo, pickupTimeFrom } = data;

    // if (
    //   Object.keys(scheduledDate).length <= 0 &&
    //   currentStepIndex === 4 &&
    //   IsScheduled === "yes"
    // ) {
    //   toast.error("Please select scheduled date.");
    //   return false;
    // } else if (transitCost.length === 0 && currentStepIndex === 5) {
    //   toast.error("Please Select Shipment Arrival Date And Shipment Process.");
    //   return false;
    // } else if (
    //   pickupTimeFrom === "" &&
    //   currentStepIndex === 4 &&
    //   IsScheduled === "yes"
    // ) {
    //   toast.error("Please select From time.");
    //   return false;
    // } else if (
    //   pickupTimeTo === "" &&
    //   currentStepIndex === 4 &&
    //   IsScheduled === "yes"
    // ) {
    //   toast.error("Please select scheduled To time.");
    //   return false;
    // } else if (IsScheduled === "" && currentStepIndex === 4) {
    //   toast.error("You have to select at least one option.");
    //   return false;
    // }

    return true;
  };

  function formatDate(dateObj) {
    // Helper function to get the month number from the month name
    function getMonthNumber(monthName) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months.indexOf(monthName);
    }

    // Extract and format the year, month, and day
    let year = parseInt(dateObj?.year?.trim());
    let month = getMonthNumber(dateObj?.month); // Zero-based month index for Date object
    let day = parseInt(dateObj?.day);

    // Set a default time (12:11:39.027) or you can set it as per your requirement
    let hours = 12;
    let minutes = 11;
    let seconds = 39;
    let milliseconds = 27;

    // Create the Date object
    let date = new Date(
      Date.UTC(year, month, day, hours, minutes, seconds, milliseconds),
    );

    // Convert to ISO 8601 format and return
    return date?.toISOString();
  }

  function combineDateAndTime(dateStr, timeStr) {
    // Extract year, month, and day from the date string
    const [year, month, day] = dateStr.split("-").map(Number);

    // Extract hours and minutes from the time string
    const [hours, minutes] = timeStr.split(":").map(Number);

    // Create the Date object with the provided date and time
    const date = new Date(Date.UTC(year, month - 1, day, hours, minutes));

    // Convert to ISO 8601 format and return
    return date?.toISOString();
  }

  function formatDateToString(dateObj) {
    // Helper function to get the month number from the month name
    function getMonthNumber(monthName) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months.indexOf(monthName) + 1;
    }

    // Extract and format the year, month, and day
    let year = dateObj?.year?.trim();
    let month = getMonthNumber(dateObj.month)?.toString()?.padStart(2, "0");
    let day = dateObj?.day?.padStart(2, "0");

    // Combine into the desired format
    return `${year}-${month}-${day}`;
  }

  // get booking page url.
  const url = useHref();
  console.log(url);

  const fetchTotalTransitionCost = async () => {
    const shipmentDefaults = getDefaultShipmentFields();
    updateFields(shipmentDefaults);

    const bookingData = { ...data, ...shipmentDefaults };
    const {
      route,
      productLength,
      productWeight,
      productHeight,
      productWidth,
      packaging,
      IsScheduled,
      producDetails,
    } = bookingData;

    const routingTypeId = parseInt(route);
    const parcelLength = parseFloat(productLength);
    const parcelWidth = parseFloat(productWidth);
    const parcelHeight = parseFloat(productHeight);
    const parcelWeight = parseFloat(productWeight);
    const cargoTypeId = DEFAULT_CARGO_TYPE_ID;
    const isExtraPackaging = packaging === "Yes";
    const isPickUp = IsScheduled === "yes";
    const selectedShipmentArrivalDate =
      bookingData.selectedShipmentArrivalDate;

    try {
      const transitionCostRequests = producDetails
        .filter((item) => {
          const itemTypeId = parseInt(item.productType);
          const itemCategoryId = parseInt(item.productGroup);
          return (
            !isNaN(itemTypeId) &&
            !isNaN(itemCategoryId) &&
            itemTypeId > 0 &&
            itemCategoryId > 0
          );
        })
        .map((item, index) => {
          const itemTypeId = parseInt(item.productType);
          const itemCategoryId = parseInt(item.productGroup);
          const productQty = parseInt(item.productQty) || 0;

          const itemParcelLength = parseFloat(
            item.itemLength !== undefined && item.itemLength !== ""
              ? item.itemLength
              : index === 0
                ? parcelLength
                : 0,
          );
          const itemParcelWidth = parseFloat(
            item.itemWidth !== undefined && item.itemWidth !== ""
              ? item.itemWidth
              : index === 0
                ? parcelWidth
                : 0,
          );
          const itemParcelHeight = parseFloat(
            item.itemHeight !== undefined && item.itemHeight !== ""
              ? item.itemHeight
              : index === 0
                ? parcelHeight
                : 0,
          );
          const itemParcelWeight = parseFloat(
            item.itemWeight !== undefined && item.itemWeight !== ""
              ? item.itemWeight
              : index === 0
                ? parcelWeight
                : 0,
          );

          const itemIsExtraPackaging =
            (item.itemPackaging !== undefined
              ? item.itemPackaging
              : index === 0
                ? packaging
                : "No") === "Yes";

          return {
            routingTypeId,
            parcelLength: itemParcelLength,
            parcelWidth: itemParcelWidth,
            parcelHeight: itemParcelHeight,
            parcelWeight: itemParcelWeight,
            cargoTypeId,
            isExtraPackaging: itemIsExtraPackaging,
            isPickUp,
            itemTypeId,
            itemCategoryId,
            shipmentArrivalDate: selectedShipmentArrivalDate,
            productQty,
            deliveryPlanId: item.deliveryPlanId
              ? parseInt(item.deliveryPlanId, 10)
              : null,
          };
        });

      if (transitionCostRequests.length === 0) {
        toast.error("Please complete parcel product details.");
        return false;
      }

      const missingPlan = (data.producDetails || []).some((item) => {
        const isFruit =
          item.productGroup === 19 || parseInt(item.productGroup, 10) === 19;
        return !isFruit && item.deliveryPlanChoiceRequired && !item.deliveryPlanId;
      });
      if (missingPlan) {
        toast.error("Select a delivery plan for each parcel.");
        return false;
      }

      const apiUrl = `${process.env.REACT_APP_API_URL}TransitionCost/GetTotalTransitionCost`;
      const response = await axios.post(apiUrl, transitionCostRequests, {
        headers: { "Content-Type": "application/json" },
      });

      const transitionCostResults = (
        Array.isArray(response.data) ? response.data : [response.data]
      )
        .filter(Boolean)
        .map((row, index) =>
          alignTransitionCostWithDeliveryPlan(
            row,
            transitionCostRequests[index],
          ),
        );

      const rowNet = (result) =>
        parseFloat(
          result?.totalCostWithoutVAT ?? result?.totalCost ?? 0,
        ) || 0;
      const rowVat = (result) =>
        parseFloat(
          result?.vatPercentageAmount ?? result?.vatAmount ?? 0,
        ) || 0;
      const rowGross = (result) => {
        const withVat = parseFloat(result?.totalCostWithVAT);
        if (Number.isFinite(withVat) && withVat > 0) return withVat;
        return rowNet(result) + rowVat(result);
      };

      const totalCost = transitionCostResults.reduce(
        (sum, result) => sum + rowGross(result),
        0,
      );
      const totalPickUpCost = transitionCostResults.reduce(
        (sum, result) => sum + result.pickUpCost,
        0,
      );
      const totalRouteCost = transitionCostResults.reduce(
        (sum, result) => sum + result.routeCost,
        0,
      );
      const totalItemCategoryCost = transitionCostResults.reduce(
        (sum, result) => sum + result.itemCategoryCost,
        0,
      );
      const totalItemTypeCost = transitionCostResults.reduce(
        (sum, result) => sum + result.itemTypeCost,
        0,
      );
      const totalWeightCost = transitionCostResults.reduce(
        (sum, result) => sum + result.weightCost,
        0,
      );
      const totalDimensionCost = transitionCostResults.reduce(
        (sum, result) => sum + result.dimensionCost,
        0,
      );
      const totalExtraPackagingCost = transitionCostResults.reduce(
        (sum, result) => sum + result.extraPackagingCost,
        0,
      );
      const totalCargoCost = transitionCostResults.reduce(
        (sum, result) => sum + result.cargoCost,
        0,
      );
      const vatPercentageAmount = transitionCostResults.reduce(
        (sum, result) => sum + result.vatPercentageAmount,
        0,
      );

      setTransitCost(transitionCostResults);
      setPickUpCost(totalPickUpCost);
      setRouteCost(totalRouteCost);
      setItemCategoryCost(totalItemCategoryCost);
      setItemTypeCost(totalItemTypeCost);
      setWeightCost(totalWeightCost);
      setDimensionCost(totalDimensionCost);
      setExtraPackagingCost(totalExtraPackagingCost);
      setCargoCost(totalCargoCost);
      setTotalCost(totalCost);
      setVatAmountPercentage(vatPercentageAmount);
      const suggested = walkInSuggestedGross({
        calculatedGross: totalCost,
        weightRates: walkInItemWeightRates({
          products: data.producDetails,
          fallbackKg: parcelWeight,
          routeId: routingTypeId,
          weights: fetchedFormData?.Weight || [],
          transitCost: transitionCostResults,
        }),
      });
      setData((prev) => {
        const custom = parseFloat(prev.walkInFinalPrice);
        const keepCustom =
          Boolean(prev.walkInFinalPriceEdited) &&
          Number.isFinite(custom) &&
          custom > 0 &&
          Math.abs(custom - suggested) >= 0.005;
        return {
          ...prev,
          walkInCalculatedPrice: suggested > 0 ? suggested.toFixed(2) : "",
          ...(keepCustom
            ? {}
            : {
                walkInFinalPrice: suggested > 0 ? suggested.toFixed(2) : "",
                walkInFinalPriceEdited: false,
              }),
        };
      });

      return true;
    } catch (error) {
      console.log(error);
      toast.error("Failed to calculate shipping cost.");
      return false;
    }
  };

  const onSubmit = async (e) => {
    console.log("Current Step Index:", currentStepIndex);
    e.preventDefault();

    // if ([3, 4, 5].includes(currentStepIndex) && !validateFields()) return;
    // if (!isLastStep) return next();

    const senderStepIndex = 1;
    if (!isMangoFlow && !isWalkInFlow && currentStepIndex === senderStepIndex) {
      const senderEmailResult = validateEmail(data.senderEmail, { required: true });
      if (!senderEmailResult.valid) {
        toast.error(senderEmailResult.error || "Sender email is required.");
        return;
      }
    }

    // Validate receiver form postcode if country is UK (standard flow only)
    if (!isMangoFlow && currentStepIndex === receiverStepIndex) {
      if (!isWalkInFlow) {
        const receiverEmailResult = validateEmail(data.receiverEmail, {
          required: true,
        });
        if (!receiverEmailResult.valid) {
          toast.error(receiverEmailResult.error || "Receiver email is required.");
          return;
        }
      }
      const { receiverPostCode, receiverCountry } = data;
      const { country } = fetchedFormData;

      // Check if country is UK
      const isUK =
        receiverCountry === "22" ||
        receiverCountry === 22 ||
        country
          ?.find((c) => String(c.id) === String(receiverCountry))
          ?.name?.toLowerCase() === "uk";

      if (isUK && receiverPostCode) {
        try {
          const validation = await validateAndFormatPostCodeFromWeb(
            receiverPostCode.trim(),
            receiverCountry,
            country || [],
          );
          if (!validation.isValid) {
            toast.error(
              `Invalid post code: ${validation.error}. Please enter a valid UK post code.`,
              {
                position: "top-right",
                autoClose: 5000,
              },
            );
            return; // Don't proceed to next step
          }
          // Update formatted postcode if different
          if (validation.formatted !== receiverPostCode.trim()) {
            updateFields({ receiverPostCode: validation.formatted });
          }
        } catch (error) {
          console.error("Post code validation error:", error);
          // Fallback to format validation
          const formatValidation = validatePostCode(
            receiverPostCode.trim(),
            receiverCountry,
            country || [],
          );
          if (!formatValidation.isValid) {
            toast.error(
              `Invalid post code: ${formatValidation.error}. Please enter a valid UK post code.`,
              {
                position: "top-right",
                autoClose: 5000,
              },
            );
            return; // Don't proceed to next step
          }
        }
      } else if (isUK && !receiverPostCode) {
        toast.error("Please enter a post code for UK addresses.", {
          position: "top-right",
          autoClose: 5000,
        });
        return; // Don't proceed to next step
      }
    }

    if (isWalkInFlow && currentStepIndex === walkInAccountStepIndex) {
      const accountError = validateWalkInAccounts(data);
      if (accountError) {
        toast.error(accountError);
        return;
      }
    }

    // Parcel step: dimensions/weight only. Delivery plan is the next page.
    if (!isMangoFlow && currentStepIndex === parcelStepIndex) {
      if (!validateFields()) {
        return;
      }
      return next();
    }

    if (!isMangoFlow && currentStepIndex === deliveryStepIndex) {
      const costOk = await fetchTotalTransitionCost();
      if (!costOk) return;
      return next();
    }

    // Walk-in: payment choice then summary, create on the last tab
    if (isWalkInFlow && currentStepIndex === paymentMethodStepIndex) {
      return next();
    }
    if (isWalkInFlow && isLastStep) {
      await handleFinalSubmit({
        suppressSlipOpen: true,
        suppressRedirect: true,
        createManualInvoice: true,
      });
      return;
    }

    // If we're on the payment method selection step
    if (currentStepIndex === paymentMethodStepIndex) {
      const isManual = String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID;
      const ok = await handleFinalSubmit({
        // Open /paymentslip as the invoice page for manual bank transfer
        suppressSlipOpen: !isManual,
        suppressRedirect: true,
        createManualInvoice: isManual,
      });
      if (ok) next();
      return;
    }

    // Manual bank transfer: invoice page already opened — finish after user confirms
    if (
      isLastStep &&
      String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
    ) {
      Swal.fire({
        title: "Booking created",
        html: manualInvoiceNumber
          ? `Your invoice has been opened. Please transfer using invoice <strong>${manualInvoiceNumber}</strong> as the payment reference. An admin will verify your payment.`
          : "Your invoice has been opened. Please complete the bank transfer using the invoice number as payment reference. An admin will verify your payment.",
        icon: "success",
        confirmButtonText: "Go to Dashboard",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        if (url === "/agency-bookings") {
          move("/agent-dashboard");
        } else if (url === "/admin-bookings" || isWalkInFlow) {
          move(isWalkInFlow ? "/admin-dashboard/walk-in-booking" : "/admin-dashboard");
        } else {
          move("/user-dashboard");
        }
      });
      return;
    }

    // For other cases, proceed to next step
    if (!isLastStep) return next();

    // Handle final submission for other payment methods
    await handleFinalSubmit();
  };

  const handleFinalSubmit = async (options = {}) => {
    const {
      suppressSlipOpen = false,
      suppressRedirect = false,
      createManualInvoice = false,
    } = options;
    if (isWalkInFlow) {
      persistWalkInWizard({ pendingSubmit: true });
      const token = await ensureFreshAccessToken();
      if (!token || isAccessTokenExpired(token || getAccessToken())) {
        return false;
      }
    }
    const {
      senderName,
      senderEmail,
      senderAddress,
      senderLandmark,
      senderMobileNumber,
      senderPostCode,
      senderDoorNo,
      senderStreetName,
      senderRemarks,
      receiverName,
      receiverEmail,
      receiverAddress,
      receiverLandmark,
      receiverMobileNumber,
      receiverPostCode,
      receiverDoorNo,
      receiverStreetName,
      receiverRemarks,
      itemDescription,
      additionalInfo = "N/A", // Default if empty
      pickupTimeFrom,
      pickupTimeTo,
      pickupInstructions,
      producDetails,
    } = data;

    // Get currency info
    const selectedCurrencyType = currencyTypes.find(
      (currency) => currency.currencyType === selectedCurrency,
    );
    const currencyTypeId = selectedCurrencyType?.id;

    if (!currencyTypeId) {
      toast.error("Invalid currency selected");
      return;
    }

    // Get conversion rate
    const conversionRate = getRate(selectedCurrency);

    // Conversion function
    const convertCost = (amount) => (amount * conversionRate).toFixed(2);

    // Prepare products array with all items
    const products = producDetails.map((item, index) => {
      // Get per-item costs from transitCost
      const itemTransitCost = transitCost[index] || transitCost[0] || {};
      const itemWeightId = itemTransitCost.weightCostId || 0;
      const itemDimensionId = itemTransitCost.dimensionId || 0;
      const itemWeightCost = parseFloat(
        convertCost(itemTransitCost.weightCost || 0),
      );
      const itemDimensionCost = parseFloat(
        convertCost(itemTransitCost.dimensionCost || 0),
      );
      const itemItemCategoryCost = parseFloat(
        convertCost(itemTransitCost.itemCategoryCost || 0),
      );
      const itemItemTypeCost = parseFloat(
        convertCost(itemTransitCost.itemTypeCost || 0),
      );
      const itemExtraPackagingCost = parseFloat(
        convertCost(itemTransitCost.extraPackagingCost || 0),
      );
      const itemCargoCost = parseFloat(
        convertCost(itemTransitCost.cargoCost || 0),
      );

      const parcelLength = parseFloat(
        item.itemLength !== undefined && item.itemLength !== ""
          ? item.itemLength
          : index === 0
            ? data.productLength
            : 0,
      ) || 0;
      const parcelWidth = parseFloat(
        item.itemWidth !== undefined && item.itemWidth !== ""
          ? item.itemWidth
          : index === 0
            ? data.productWidth
            : 0,
      ) || 0;
      const parcelHeight = parseFloat(
        item.itemHeight !== undefined && item.itemHeight !== ""
          ? item.itemHeight
          : index === 0
            ? data.productHeight
            : 0,
      ) || 0;
      const parcelWeight = parseFloat(
        item.itemWeight !== undefined && item.itemWeight !== ""
          ? item.itemWeight
          : index === 0
            ? data.productWeight
            : 0,
      ) || 0;

      return {
        itemCategoryId: parseInt(item.productGroup),
        itemCategoryCost: itemItemCategoryCost,
        itemTypeId: parseInt(item.productType),
        itemTypeCost: itemItemTypeCost,
        dimensionId: itemDimensionId,
        dimensionCost: itemDimensionCost,
        weightId: itemWeightId,
        weightCost: itemWeightCost,
        uniqItemDescription: item.itemDescription || itemDescription || "",
        itemValue: parseFloat(convertCost(item.productValue)),
        isExtraPackaging:
          (item.itemPackaging !== undefined
            ? item.itemPackaging
            : index === 0
              ? data.packaging
              : "No") === "Yes",
        extraPackagingCost: itemExtraPackagingCost,
        parcelAdditionalInfo: additionalInfo,
        cargoTypeId: parseInt(data.cargoType, 10) || DEFAULT_CARGO_TYPE_ID,
        cargoCost: itemCargoCost,
        productQty: parseInt(item.productQty) || 0,
        parcelLength,
        parcelWidth,
        parcelHeight,
        parcelWeight,
        customerParcelLength: parcelLength,
        customerParcelWidth: parcelWidth,
        customerParcelHeight: parcelHeight,
        customerParcelWeight: parcelWeight,
      };
    });

    // Prefer live transitCost rows (same payable shown on Finalize / invoice).
    // Payable = totalCostWithVAT when present, else net + VAT.
    const transitCostNet = Array.isArray(transitCost)
      ? transitCost.reduce(
          (sum, tc) =>
            sum +
            (parseFloat(tc?.totalCostWithoutVAT ?? tc?.totalCost ?? 0) || 0),
          0,
        )
      : 0;
    const transitCostVat = Array.isArray(transitCost)
      ? transitCost.reduce(
          (sum, tc) =>
            sum +
            (parseFloat(tc?.vatPercentageAmount ?? tc?.vatAmount ?? 0) || 0),
          0,
        )
      : 0;
    const transitCostGross = Array.isArray(transitCost)
      ? transitCost.reduce((sum, tc) => {
          const withVat = parseFloat(tc?.totalCostWithVAT);
          if (Number.isFinite(withVat) && withVat > 0) return sum + withVat;
          const net =
            parseFloat(tc?.totalCostWithoutVAT ?? tc?.totalCost ?? 0) || 0;
          const vat =
            parseFloat(tc?.vatPercentageAmount ?? tc?.vatAmount ?? 0) || 0;
          return sum + net + vat;
        }, 0)
      : 0;

    const calculatedNetCost =
      transitCostNet > 0 ? transitCostNet : parseFloat(totalCost) || 0;
    const calculatedVatAmount =
      transitCostVat > 0
        ? transitCostVat
        : parseFloat(vatAmountPercentage) || 0;
    const calculatedTotalCost =
      transitCostGross > 0
        ? transitCostGross
        : calculatedNetCost + calculatedVatAmount;

    const walkInPayable = isWalkInFlow
      ? applyWalkInFinalPrice(
          calculatedTotalCost,
          calculatedNetCost,
          calculatedVatAmount,
          data.walkInFinalPrice,
        )
      : {
          gross: calculatedTotalCost,
          net: calculatedNetCost,
          vat: calculatedVatAmount,
          overridden: false,
        };

    const effectiveNetCost = walkInPayable.net;
    const effectiveVatAmount = walkInPayable.vat;
    const effectiveTotalCost = walkInPayable.gross;

    if (!(effectiveTotalCost > 0)) {
      toast.error(
        "Booking amount is £0. Please go back and recalculate shipping cost before paying.",
      );
      return false;
    }

    // Subtotal = net; payable = net + VAT (matches payment / dashboard amounts)
    const totalSubTotal = parseFloat(convertCost(effectiveNetCost));
    const totalVATAmount = parseFloat(convertCost(effectiveVatAmount));
    const totalOrderPayableAmount = parseFloat(
      convertCost(effectiveTotalCost),
    );
    // Prepare single booking object with products array
    const bookingData = {
      companyId: 0,
      routingTypeId: parseInt(data.route),
      routeCost: parseFloat(convertCost(routeCost || 0)),
      senderName: senderName,
      senderEmail: senderEmail,
      senderMobileNo: senderMobileNumber,
      senderCountryId: parseInt(data.senderCountry),
      senderCityId: parseInt(data.senderCity),
      senderLandMark: senderLandmark || "",
      senderPostCode: senderPostCode || "",
      senderAdditionalAddressInfo: senderAddress || "",
      senderDoorNo: senderDoorNo || "",
      senderStreetName: senderStreetName || "",
      senderRemarks: senderRemarks || "",
      receiverName: receiverName,
      receiverEmail: receiverEmail,
      receiverMobileNo: receiverMobileNumber,
      receiverCountryId: parseInt(data.receiverCountry),
      receiverCityId: parseInt(data.receiverCity),
      receiverLandMark: receiverLandmark || "",
      receiverPostCode: receiverPostCode || "",
      receiverAdditionalAddressInfo: receiverAddress || "",
      receiverDoorNo: receiverDoorNo || "",
      receiverStreetName: receiverStreetName || "",
      receiverRemarks: receiverRemarks || "",
      isPickup: data.IsScheduled === "yes",
      pickupDate:
        data.IsScheduled === "yes"
          ? formatDate(data.scheduledDate)
          : "2024-07-24",
      fromTime:
        data.IsScheduled === "yes"
          ? combineDateAndTime(
              formatDateToString(data.scheduledDate),
              pickupTimeFrom,
            )
          : "2024-07-24",
      toTime:
        data.IsScheduled === "yes"
          ? combineDateAndTime(
              formatDateToString(data.scheduledDate),
              pickupTimeTo,
            )
          : "2024-07-24",
      pickUpCountryId:
        data.IsScheduled === "yes" ? parseInt(data.pickupCountry) : 0,
      pickUpCityId: data.IsScheduled === "yes" ? parseInt(data.pickupCity) : 0,
      pickUpLandMark: data.senderLandmark || "",
      pickUpAdditionalAddressInfo: data.senderAddress || "",
      parcelPickUpInstractions: pickupInstructions || "",
      pickupCost: parseFloat(convertCost(pickUpCost || 0)),
      subTotal: totalSubTotal,
      vaT_TaxParcentage: 0,
      vaT_TaxAmount: totalVATAmount,
      orderPayableAmount: totalOrderPayableAmount,
      shippingServiceId: 0,
      shippingServicePercentage: 0,
      shippingServiceAmount: parseFloat(
        convertCost(shippingServiceAmount || 0),
      ),
      discountPercentage: 0,
      discountedOfferId: 0,
      discountAmount: parseFloat(convertCost(discountAmount || 0)),
      isAgent: tittle === "Agency Booking" && localStorageObj?.Type === "Agent",
      agentId:
        localStorageObj?.Id && tittle === "Agency Booking"
          ? String(localStorageObj?.Id)
          : "",
      branchId: 1,
      paymentTypeMethodId: parseInt(data?.paymentTypeId),
      paymentInvoiceNo: data?.paymentInvoiceNo || "",
      bookedById: userId || GetLocalStorageUserId() || "",
      currencyTypeId: currencyTypeId,
      creatorId: GetLocalStorageUserId() || "",
      modifierId: GetLocalStorageUserId() || "",
      isActive: true,
      products: products,
    };

    console.log("Booking Data:", bookingData);

    try {
      let bookingResults = [];
      let walkInCreateResult = null;
      if (isWalkInFlow) {
        const walkInAccountPayload = buildWalkInAccountPayload(data);
        const walkInResult = await createAdminWalkInBooking(
          buildAdminWalkInCreateBody(bookingData, walkInAccountPayload),
        );
        walkInCreateResult = walkInResult;
        skipWalkInDraftRef.current = true;
        if (serverDraftTimerRef.current) {
          window.clearTimeout(serverDraftTimerRef.current);
          serverDraftTimerRef.current = null;
        }
        clearWalkInDraft();
        const fallbackAccounts = [];
        if (walkInAccountPayload.senderAccountMode === "New") {
          fallbackAccounts.push({
            party: "Sender",
            userName: walkInAccountPayload.senderUserName,
            password: walkInAccountPayload.senderPassword,
            email: walkInAccountPayload.senderEmail,
            isNew: true,
          });
        }
        if (walkInAccountPayload.receiverAccountMode === "New") {
          fallbackAccounts.push({
            party: "Receiver",
            userName: walkInAccountPayload.receiverUserName,
            password: walkInAccountPayload.receiverPassword,
            email: walkInAccountPayload.receiverEmail,
            isNew: true,
          });
        }
        setWalkInStayOnForm(Boolean(suppressRedirect));
        setWalkInSuccess({
          ...walkInResult,
          createdAccounts:
            walkInResult.createdAccounts?.length > 0
              ? walkInResult.createdAccounts.map((account) => {
                  const fallback = fallbackAccounts.find(
                    (item) =>
                      item.party.toLowerCase() ===
                      String(account.party || "").toLowerCase(),
                  );
                  return {
                    ...account,
                    password: account.password || fallback?.password || "",
                    userName: account.userName || fallback?.userName || "",
                  };
                })
              : fallbackAccounts,
        });
        bookingResults = [
          {
            ...(walkInResult.raw || {}),
            parcelId: walkInResult.parcelId,
            id: walkInResult.parcelId,
            recordSerialNo: walkInResult.recordSerialNo,
            number: walkInResult.recordSerialNo,
          },
        ];
      } else {
        const response = await axios.post(`${apiAddress}TransitionCost`, [
          bookingData,
        ]);
        if (response.status !== 200) {
          toast.error("Failed to create booking.");
          return false;
        }
        bookingResults = Array.isArray(response.data) ? response.data : [];
      }

      if (bookingResults) {
        // Backend returns array of results - use first one for parent booking info
        // All items should share the same parent booking
        if (!isWalkInFlow) {
          markSelfParcelBookingCreated(bookingResults);
        }
        if (isAdminUser()) {
          dispatchNotificationsRefresh();
        } else if (isCustomerUser()) {
          refreshCustomerDashboardData().catch(() => {});
        }

        const returnedData =
          bookingResults.length > 0 ? bookingResults[0] : {};

        const mappedTransit = transitCost.map((tc) => {
            const net =
              parseFloat(tc.totalCostWithoutVAT ?? tc.totalCost ?? 0) || 0;
            const vat =
              parseFloat(tc.vatPercentageAmount ?? tc.vatAmount ?? 0) || 0;
            const withVat =
              parseFloat(tc.totalCostWithVAT) ||
              (net > 0 || vat > 0 ? net + vat : 0);
            return {
              ...tc,
              totalCost: convertCost(withVat || tc.totalCost),
              discountAmount: convertCost(tc.discountAmount),
              totalCostWithoutVAT: convertCost(net),
              totalCostWithVAT: convertCost(withVat),
              vatPercentageAmount: convertCost(vat),
            };
          });
        const paymentSlipData = {
          ...data,
          pricingType: isMangoFlow ? "mango" : "regular",
          isMangoBooking: isMangoFlow,
          transitCost: isWalkInFlow
            ? applyPayableOverrideToTransitCost(mappedTransit, {
                ...walkInPayable,
                gross: totalOrderPayableAmount,
                net: totalSubTotal,
                vat: totalVATAmount,
              })
            : mappedTransit,
          orderPayableAmount: totalOrderPayableAmount,
          subTotal: totalSubTotal,
          vatAmount: totalVATAmount,
          walkInFinalPrice: data.walkInFinalPrice,
          bookingBarcodeNumber: returnedData?.number || returnedData?.barcode,
          parcelId: returnedData?.parcelId || returnedData?.id,
          recordSerialNo: returnedData?.recordSerialNo,
          currencyType: selectedCurrency,
          currencyTypeId,
          producDetails: data.producDetails.map((item) => ({
            ...item,
            productValue: item.productValue,
            productGroupName: item.productGroupName,
            productTypeName: item.productTypeName,
          })),
        };

        if (createManualInvoice || isWalkInFlow) {
          try {
            let invoiceNo =
              walkInCreateResult?.paymentInvoiceNo ||
              paymentSlipData.paymentInvoiceNo ||
              "";
            if (!invoiceNo && paymentSlipData.parcelId) {
              try {
                const invoices = await getInvoicesByParcelId(
                  paymentSlipData.parcelId,
                );
                invoiceNo = invoiceNumberOf(pickLatestInvoice(invoices));
              } catch {
                /* create below */
              }
            }
            if (!invoiceNo) {
              const invoiceResult = await createManualBankPaymentInvoice({
                parcelId: paymentSlipData.parcelId,
                recordSerialNo: paymentSlipData.recordSerialNo,
                orderAmount: totalOrderPayableAmount,
                currencyTypeId,
                bookedById: userId || GetLocalStorageUserId() || "",
                description: `${
                  isWalkInFlow ? "Walk-in booking" : "Manual bank transfer"
                } for ${
                  paymentSlipData.recordSerialNo ||
                  paymentSlipData.bookingBarcodeNumber ||
                  ""
                }`,
              });
              invoiceNo = invoiceResult.invoiceNumber;
            }

            paymentSlipData.paymentInvoiceNo = invoiceNo;
            paymentSlipData.paymentTypeId =
              String(data?.paymentTypeId || "") || MANUAL_PAYMENT_TYPE_ID;
            setManualInvoiceNumber(invoiceNo);
            setManualOrderAmount(String(totalOrderPayableAmount));
            updateFields({
              paymentInvoiceNo: invoiceNo,
              paymentTypeId: paymentSlipData.paymentTypeId,
            });
          } catch (invoiceErr) {
            console.error("Manual invoice creation failed:", invoiceErr);
            toast.error(
              "Booking created, but invoice number could not be generated. Please contact support.",
            );
          }
        }

        // Store in localStorage
        localStorage.setItem(
          "paymentSlipData",
          JSON.stringify(paymentSlipData),
        );
        // Capture customer booking measurements for later remesaure invoice V1 slips
        if (paymentSlipData.parcelId) {
          saveOriginalMeasurementSnapshot(
            paymentSlipData.parcelId,
            paymentSlipData.producDetails || [],
          );
        }
        clearPaymentSlipUploadSessionFlags(
          paymentSlipData.parcelId,
          paymentSlipData.recordSerialNo,
        );
        // Mark booking API flow complete (Stripe step can start now)
        sessionStorage.setItem("bookingApisCompleted", "1");

        // GTM: booking_complete data layer push (only once per booking)
        try {
          const bookingId =
            returnedData?.recordSerialNo ||
            returnedData?.parcelId ||
            returnedData?.id ||
            paymentSlipData.bookingBarcodeNumber;

          if (
            bookingId &&
            window.__bookingCompletePushed !== String(bookingId)
          ) {
            const totalAmount = totalSubTotal;

            const productQtyTotal = Array.isArray(producDetails)
              ? producDetails.reduce(
                  (sum, item) => sum + (parseInt(item.productQty) || 0),
                  0,
                )
              : 0;

            // Sum all item weights (fallback to global productWeight if needed)
            const totalWeightKg = Array.isArray(producDetails)
              ? producDetails.reduce(
                  (sum, item) =>
                    sum +
                    (parseFloat(item.itemWeight || item.productWeight || 0) ||
                      0),
                  0,
                )
              : parseFloat(data.productWeight || 0) || 0;

            // Route as human-readable route name, e.g. "Dhaka → London"
            const selectedRoute =
              fetchedFormData?.Route && Array.isArray(fetchedFormData.Route)
                ? fetchedFormData.Route.find(
                    (r) => String(r.id) === String(data.route),
                  )
                : null;
            const routeLabel =
              selectedRoute?.routeName ||
              (selectedRoute?.startingArea && selectedRoute?.endingArea
                ? `${selectedRoute.startingArea} \u2192 ${selectedRoute.endingArea}`
                : "");

            // Parcel type from first product's category name
            const parcelType =
              Array.isArray(producDetails) && producDetails.length > 0
                ? producDetails[0].productGroupName || ""
                : "";

            // Shipping service name (e.g. "Express", "Standard"), from transitCost
            const serviceType =
              Array.isArray(transitCost) && transitCost.length > 0
                ? transitCost[0]?.shippingServiceName || ""
                : "";

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "booking_complete",
              booking: {
                booking_id: String(bookingId),
                booking_status: "confirmed",
                booking_date: new Date()
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " "),
                route: routeLabel,
                service_type: serviceType,
                parcel_type: parcelType,
                weight_kg: totalWeightKg,
                quantity: productQtyTotal,
                total_amount: totalAmount,
                currency: selectedCurrency || "GBP",
                payment_method:
                  String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
                    ? "bank_transfer"
                    : "stripe",
                payment_status: "unpaid",
                invoice_number: paymentSlipData.paymentInvoiceNo || "",
              },
              customer: {
                customer_id: localStorageObj?.Id
                  ? String(localStorageObj.Id)
                  : "",
                name: senderName || "",
                phone: senderMobileNumber || "",
                email: senderEmail || "",
                city: data.senderCity || "",
                country: data.senderCountry || "",
              },
            });

            // Mark as pushed to avoid duplicate firing on reload
            window.__bookingCompletePushed = String(bookingId);
          }
        } catch (e) {
          console.error("GTM booking_complete dataLayer push failed:", e);
        }

        // Clear pricing draft from localStorage after successful booking
        localStorage.removeItem("sundorbonPricingDraft");

        setBookingBarcodeNumber(
          returnedData?.number || returnedData?.recordSerialNo || null,
        );

        if (!suppressSlipOpen) {
          window.open("/paymentslip", "_blank");
        }

        if (isWalkInFlow) {
          setWalkInSuccess((prev) =>
            prev
              ? {
                  ...prev,
                  paymentInvoiceNo: paymentSlipData.paymentInvoiceNo,
                  paymentSlipData,
                }
              : {
                  ...walkInCreateResult,
                  paymentInvoiceNo: paymentSlipData.paymentInvoiceNo,
                  paymentSlipData,
                },
          );
          toast.success(
            paymentSlipData.paymentInvoiceNo
              ? `Walk-in booking created. Invoice ${paymentSlipData.paymentInvoiceNo}`
              : "Walk-in booking created.",
          );
          return true;
        }

        if (suppressRedirect) {
          toast.success("Booking created. Please complete payment.");
          return true;
        }

        Swal.fire({
          title: "Booking created successfully",
          text: "Payment slip has been opened in a new tab.",
          icon: "success",
          confirmButtonText: "Go to Dashboard",
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (
            result.isConfirmed ||
            result.dismiss === Swal.DismissReason.backdrop
          ) {
            // Redirect based on the booking page URL
            if (url === "/agency-bookings") {
              move("/agent-dashboard");
            } else if (url === "/admin-bookings") {
              move("/admin-dashboard");
            } else if (url === "/bookings") {
              move("/user-dashboard");
            } else {
              // Default fallback
              move("/user-dashboard");
            }
          }
        });
        return true;
      }
    } catch (error) {
      console.error("Booking error:", error.response?.data || error);
      toast.error(
        `Failed to create booking: ${error.response?.data?.title || error.message}`,
      );
      return false;
    }
  };

  const stepNames = isMangoFlow
    ? [
        "Receiver",
        "Parcel",
        "Create shipment",
        "Payment Method",
        ...(data.paymentTypeId === "2" ? ["Online Payment"] : []),
        ...(String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
          ? ["Bank Transfer"]
          : []),
      ]
    : [
        "Route",
        "Sender",
        "Receiver",
        ...(isWalkInFlow
          ? ["Accounts", "Parcel", "Delivery", "Payment", "Summary"]
          : [
              "Parcel",
              "Delivery",
              "Review",
              "Payment Method",
              ...(data.paymentTypeId === "2" ? ["Online Payment"] : []),
              ...(String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
                ? ["Bank Transfer"]
                : []),
            ]),
      ];

  console.log("data", data);
  console.log(vatAmountPercentage);
  const walkInNav = (
    <div className="admin-walkin-nav flex gap-1 overflow-x-auto pb-1 mb-3">
      {stepNames.map((name, idx) => {
        const active = idx === currentStepIndex;
        const done = idx < currentStepIndex;
        return (
          <button
            key={name}
            type="button"
            onClick={() => {
              if (idx <= currentStepIndex) goTo(idx);
            }}
            className={`shrink-0 px-2.5 h-7 rounded-md text-[11px] font-semibold ${
              active
                ? "bg-orange-600 text-white"
                : done
                  ? "bg-stone-900 text-white"
                  : "bg-stone-100 text-stone-500"
            }`}
          >
            {idx + 1}. {name}
          </button>
        );
      })}
    </div>
  );

  if (isAdminEmbed) {
    return (
      <div className="admin-walkin-wizard w-full">
        {isWalkInFlow && walkInSuccess ? (
          <WalkInSuccessModal
            result={walkInSuccess}
            onClose={() => {
              const created = walkInSuccess;
              skipWalkInDraftRef.current = true;
              if (serverDraftTimerRef.current) {
                window.clearTimeout(serverDraftTimerRef.current);
                serverDraftTimerRef.current = null;
              }
              clearWalkInDraft();
              setWalkInSuccess(null);
              if (typeof onWalkInCreated === "function") {
                onWalkInCreated(created);
              }
            }}
          />
        ) : null}
        {walkInNav}
        <div
          className={`admin-walkin-layout ${
            isWalkInFlow ? "admin-walkin-layout--with-summary" : ""
          }`}
        >
          <form onSubmit={onSubmit} className="admin-walkin-form">
            <div className="admin-walkin-form__body">{step}</div>
            <div className="admin-walkin-form__actions">
              {!isFirstStep ? (
                <button
                  type="button"
                  onClick={back}
                  className="admin-walkin-nav-btn h-8 px-3 rounded-lg border border-stone-200 bg-white text-xs font-semibold text-stone-700 hover:bg-stone-50"
                >
                  Back
                </button>
              ) : null}
              <button
                type="submit"
                className="admin-walkin-nav-btn h-8 px-4 rounded-lg bg-orange-600 text-white text-xs font-semibold hover:bg-orange-700"
              >
                {isLastStep ? "Create booking" : "Next"}
              </button>
              {isWalkInFlow ? (
                <>
                  <button
                    type="button"
                    onClick={async () => {
                      const saved = await flushWalkInDraftToServer();
                      if (!saved) {
                        toast.info("Enter a route or customer before saving a draft.");
                        return;
                      }
                      toast.success("Draft saved to the server. Continue later from Drafts.");
                    }}
                    className="admin-walkin-nav-btn h-8 px-3 rounded-lg border border-stone-200 bg-white text-xs font-semibold text-stone-700 hover:bg-stone-50"
                  >
                    Save draft
                  </button>
                  <button
                    type="button"
                    onClick={async () => {
                      const saved = await flushWalkInDraftToServer();
                      if (!saved) {
                        toast.info("Enter a route or customer before starting another.");
                        return;
                      }
                      skipWalkInDraftRef.current = true;
                      if (serverDraftTimerRef.current) {
                        window.clearTimeout(serverDraftTimerRef.current);
                        serverDraftTimerRef.current = null;
                      }
                      toast.success("Draft saved. Starting a new booking.");
                      if (typeof onWalkInStartAnother === "function") {
                        onWalkInStartAnother();
                      }
                    }}
                    className="admin-walkin-nav-btn h-8 px-3 rounded-lg border border-orange-200 bg-orange-50 text-xs font-semibold text-orange-800 hover:bg-orange-100"
                  >
                    Start another
                  </button>
                </>
              ) : null}
            </div>
          </form>
          {isWalkInFlow ? (
            <WalkInSummary
              variant="sidebar"
              data={data}
              fetchedFormData={fetchedFormData}
              transitCost={transitCost}
              selectedCurrency={selectedCurrency}
              totalCost={totalCost}
              vatAmountPercentage={vatAmountPercentage}
              updateFields={updateFields}
            />
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="bookingContainer lg:pb-0 pb-5 flex flex-col gap-0 justify-end items-center w-full overflow-x-hidden">
      <ToastContainer />

      {/* Form + Side image wrapper */}
      <div className="w-full flex flex-col lg:flex-row lg:items-stretch">
        {/* Left: booking form */}
        <div className="w-full lg:w-1/2 pt-11 flex flex-col">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h1 className="xl:text-5xl  lg:text-4xl text-3xl font-normal pageTittle px-4">
              {tittle}
            </h1>
            <hr className="underline-custom" />
          </div>

          <form onSubmit={onSubmit} className=" relative">
            {/* <div className="absolute top-[90px] left-0 w-full">
            <ProgressBar
              data={data}
              currentStepIndex={currentStepIndex}
              steps={steps}
              stepNames={stepNames}
            />
          </div> */}
            {/* step page container part. */}

            <div className="grid grid-cols-1 lg:flex lg:flex-row lg:items-start lg:justify-center gap-3 xl:gap-5 px-2 sm:px-4">
              <div className="w-full h-full flex flex-col items-center justify-center">
                {/* Centered Content */}
                <div className="flex justify-center items-center w-full max-w-4xl">
                  {step}
                </div>

                {/* Bottom Part */}
                {/* <div
                  className={`flex px-4 pb-4 ${
                    isFirstStep ? "flex-row-reverse" : "flex-row"
                  } items-center mt-6 gap-4`}
                >
                  {!isFirstStep && (
                    <button
                      type="button"
                      onClick={back}
                      className="bg-orange-500 border border-transparent font-medium text-white py-2 px-6 rounded-md hover:bg-orange-600 transition-all"
                    >
                      Back
                    </button>
                  )}

                  <button
                    type="submit"
                    className="bg-orange-500 border border-transparent font-medium text-white py-2 px-6 rounded-md hover:bg-orange-600 transition-all"
                  >
                    {isLastStep ? "Finish" : "Next"}
                  </button>
                </div> */}
                <div
                  className={`flex px-4 pb-4 ${
                    isFirstStep ? "flex-row-reverse" : "flex-row"
                  } items-center mt-6 gap-4`}
                >
                  {!isFirstStep &&
                    !(
                      data.paymentTypeId === "2" &&
                      currentStepIndex === allSteps.length - 1
                    ) && (
                      <button
                        type="button"
                        onClick={back}
                        className="bg-orange-500 border border-transparent font-medium text-white py-2 px-6 rounded-md hover:bg-orange-600 transition-all"
                      >
                        Back
                      </button>
                    )}
                  {/* Stripe step uses its own Pay button */}
                  {!(
                    data.paymentTypeId === "2" &&
                    currentStepIndex === allSteps.length - 1
                  ) && (
                    <button
                      type="submit"
                      className="bg-orange-500 border border-transparent font-medium text-white py-2 px-6 rounded-md hover:bg-orange-600 transition-all"
                    >
                      {isLastStep
                        ? String(data.paymentTypeId) === MANUAL_PAYMENT_TYPE_ID
                          ? "I have noted the details"
                          : "Finish"
                        : isMangoFlow &&
                            currentStepIndex === finalizeStepIndex
                          ? "Continue to payment"
                          : "Next"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
        {/* Right: side image (desktop only) */}
        <img
          src={sideImg}
          alt=""
          className="hidden lg:block lg:w-1/2 object-cover"
        />
      </div>
    </div>
  );
};

export default Bookings;
